import Api from './api';
import { ICategory } from '../interfaces/product.interface';

class CategoryApi {
  private baseUrl: string;
  constructor() {
    this.baseUrl = '/category';
  }

  async getAll(): Promise<ApiResponse<ICategory[]>> {
    return Api.GET(this.baseUrl);
  }

  async getOne(id: number): Promise<ApiResponse<ICategory>> {
    return Api.GET(this.baseUrl + `/${id}`);
  }

  async create(body: Omit<ICategory, 'id'>): Promise<ApiResponse<string>> {
    return Api.POST(this.baseUrl, body);
  }

  async update(id: number, body: Omit<ICategory, 'id'>): Promise<ApiResponse<string>> {
    return Api.PUT(this.baseUrl + `/${id}`, body);
  }

  async delete(id: number): Promise<ApiResponse<string>> {
    return Api.DELETE(this.baseUrl + `/${id}`);
  }
}

export default new CategoryApi();
